/**
 * Fonts loaded via @remotion/google-fonts for embedded video rendering
 */
import { loadFont as loadMichroma } from '@remotion/google-fonts/Michroma';
import { loadFont as loadLalezar } from '@remotion/google-fonts/Lalezar';
import { loadFont as loadInter } from '@remotion/google-fonts/Inter';
import { loadFont as loadAlexBrush } from '@remotion/google-fonts/AlexBrush';

export const { fontFamily: michromaFontFamily } = loadMichroma();
export const { fontFamily: lalezarFontFamily } = loadLalezar();
export const { fontFamily: alexBrushFontFamily } = loadAlexBrush();
export const { fontFamily: interFontFamily } = loadInter('normal', {
  weights: ['400', '500', '600', '700', '800', '900'],
  subsets: ['latin'],
});
